import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FilterDialogComponent } from './filter-dialog.component';
import { DialogService } from '@teammood/shared/ui/dialog';
import { NamedFilter } from '../named-filter.type';

@Injectable(
  { providedIn: 'root' }
)
export class FilterDialogService {
    constructor(
      private _dialogService: DialogService,
    ){}
  async openFilterDialog(namedFilter: NamedFilter, mode: 'update' | 'create'): Promise<MatDialogRef<FilterDialogComponent>> {
    return this._dialogService.open(FilterDialogComponent, {
      width: '100%',
      maxWidth: '800px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      data: {
        namedFilter: namedFilter,
        mode: mode
      }
    })
  }

}